module.exports = __webpack_public_path__ + "img/model-bg.c385a3e2.png";